import Cities from './containers/Cities';
import reducer from './services/reducer';
import { CitiesState, citiesSelectors } from './services/selectors';
import epics from './services/epics';

export { reducer, CitiesState, citiesSelectors, epics };

export default Cities;



// WEBPACK FOOTER //
// ./src/scenes/Cities/index.ts